import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Preview from './preview';
import { AgGridReact } from 'ag-grid-react';
import { useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { NameFormatter } from '../../shared/controls/formatters';
import { getAllTemplate } from '../../redux/selector';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../shared/component/Loader';

const SelectTemplate = ({ selectedOptions, handleClose, handleChange, handleSubmit, module }) => {
  const [showPreviewPopup, setPreviewPopup] = useState(false);
  const [selectedTemplateContent, setSelectedTemplateContent] = useState(''); // Store selected template content
  const rowData = useSelector(getAllTemplate)

  // const rowData = useFetchIfNeeded(getAllTemplate, fetchDataAndUpdateStore, {
  //   key: 'template',
  // });

  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'template');
  const gridRef = useRef();
  const [loading, setLoading] = useState(storeLoading);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [selectedRows, setSelectedRows] = useState(false);
  const location = useLocation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [previewData, setPreviewData] = useState();

  // Filter rowData based on the module
  useEffect(() => {
    if (module && rowData) {
      const filteredData = rowData.filter((row) =>
        row?.associatedModule?.toLowerCase().includes(module?.toLowerCase())
      );
      setFilteredRowData(filteredData); // Set filtered data
    } else {
      setFilteredRowData(rowData); // If no module, use the original rowData
    }
  }, [module, rowData]);

  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows());
  };

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const handleSubmitChild = (preview) => {
    setIsPreview(preview); // Set the preview flag
    console.log('Preview:', preview); // Log content for preview

    console.log('Template Content for Preview:', selectedRows); // Log content for preview

    handleSubmit(selectedRows, preview);
    handleClose();
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Template Name',
      field: 'name',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Template Subject',
      field: 'subject',
      filter: 'agSetColumnFilter',

      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Associated Module',
      field: 'associatedModule',

      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Template Type',
      field: 'templateType',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Preview',
      sortable: false,
      filter: false,
      cellRenderer: (params) => {
        return (
          <button
            className="btn btn-link"
            style={{
              padding: '0',
              margin: '0',
              minWidth: 'auto',
            }}
            onClick={() => handlePreview(params.data)}
            type="button"
          >
            Preview
          </button>
        );
      },
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      filter: 'agSetColumnFilter',
      valueFormatter: NameFormatter,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));
  const openPreviewPopup = () => {
    setPreviewPopup(true);
  };

  const closePreviewPopup = () => {
    setPreviewPopup(false);
  };

  const handlePreview = (data) => {
    setPreviewPopup(true);
    setPreviewData(data);
  };
  const onFilterTextBoxChanged = useCallback((e) => {
    const input = e.target.value;
    gridRef.current.api.setQuickFilter(input);
  }, []);

  return (
    <>
      <div id="genricPopup">
        <div className="popup-backdrop ">
          <div className="popup fullWidthPopup">
            {/* Popup Header */}
            <div
              className="popup-header"
              style={{
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
              }}
            >
              <h4 className="popup-title">
                {location.pathname.includes('view') ? 'Select Template' : 'Mass Email'}
              </h4>
              <button type="button" className="custom-btn-close" onClick={handleClose}></button>
            </div>

            {/* Popup Body */}
            <div className="popup-body custHeight">
              <div className="tblheader pt-0 px-0">
                <div className="searchBoxTable">
                  <input
                    className="form-control"
                    id="filter-text-box"
                    type="Text"
                    placeholder="Search..."
                    onInput={onFilterTextBoxChanged}
                  />
                </div>
              </div>

              <div className="cutome_ag_theme">
                {loading && <Loader />}
                <div
                  className={`ag-theme-${selectedTheme} tbl_height`}
                  style={{
                    width: '100%',
                    height: 'calc(100vh - 55vh)',
                    overflowY: 'auto',
                  }}
                >
                  <AgGridReact
                    domLayout="normal"
                    ref={gridRef} // Ref for accessing Grid's API
                    rowData={filteredRowData} // Row Data for Row
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef} // Default Column Properties
                    overlayLoadingTemplate={`<Loader />`}
                    animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                    rowSelection={'Single'} // Options - allows click selection of rows
                    enableRangeSelection={true}
                    suppressExcelExport={true}
                    suppressRowClickSelection={true}
                    groupSelectsChildren={true}
                    pivotPanelShow={'always'}
                    rowDragManaged={true}
                    suppressMoveWhenRowDragging={true}
                    rowGroupPanelShow={'always'}
                    onSelectionChanged={onSelectionChanged}
                    alwaysShowVerticalScroll={true}
                  />
                </div>
              </div>
            </div>

            {/* Popup Footer */}
            <div className="popup-footer">
              <button type="button" className="cancel-lead ld-btn" onClick={handleClose}>
                Cancel
              </button>
              <button className="save-lead ld-btn" onClick={() => handleSubmitChild(true)}>
                Select
              </button>
            </div>
          </div>
        </div>
      </div>

      {showPreviewPopup && <Preview previewData={previewData} handleClose={closePreviewPopup} />}
    </>
  );
};
export default SelectTemplate;
